import { render, staticRenderFns } from "./Theses.vue?vue&type=template&id=17af0add&scoped=true&"
import script from "./Theses.vue?vue&type=script&lang=js&"
export * from "./Theses.vue?vue&type=script&lang=js&"
import style0 from "./Theses.vue?vue&type=style&index=0&id=17af0add&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17af0add",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VCard,VChip})
